<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<button-search ref="buttonSearch" placeholder="要搜索的商品名称" @search="searchEvent" class="pt-3 pb-1">
			<!-- 左边 -->
			<template #left>
				<el-button type="primary" size="mini" icon="el-icon-plus" @click="navigate('cwgl_zcjz_fkdd_create')">添加</el-button>
				<el-button type="danger" size="mini" icon="el-icon-delete">删除</el-button>
				<el-button type="primary" size="mini" @click="opcta(multipleSelection)" icon="el-icon-s-promotion">发送消息</el-button>
				<el-dropdown class="ml-2 mr-2">
					<el-button type="success" icon="el-icon-s-promotion" size="mini">审核</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item><div style="color: #7c7eff;font-size: 12px;" @click="states(1, multipleSelection)">同意</div></el-dropdown-item>
						<el-dropdown-item><div style="color: #d00003;font-size: 12px;" @click="states(2, multipleSelection)">拒绝</div></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-button type="success" size="mini" @click="opctb(multipleSelection)" icon="el-icon-finished">结算确认</el-button>
			</template>

			<!-- 高级搜索表单 -->
			<template #form>
				<el-form inline ref="form" :model="form" label-width="80px">
					<el-form-item label="商品名称" class="mb-0"><el-input v-model="form.title" placeholder="商品名称" size="mini"></el-input></el-form-item>
					<el-form-item label="商品分类" class="mb-0">
						<el-select v-model="form.category_id" placeholder="请选择商品分类" size="mini">
							<el-option v-for="item in cateOptions" :key="item.id" :label="item | tree" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
						<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
					</el-form-item>
				</el-form>
			</template>
		</button-search>

		<el-tabs v-model="tabIndex" @tab-click="getList">
			
			<el-tab-pane :key="tabI" v-for="(tab, tabI) in tabbars">
				<span slot="label" class="d-flex">
					<div style="">{{tab.name}}</div>
					<div v-if="tab.num != 0" style="background: #ffa303;width: 24px;height: 18px;border-radius: 10px;margin-top: 6px;justify-content: center;align-items: center;" class="d-flex">
						<div style="font-size: 10px;color: #fff;font-weight: 800;">{{tab.num}}</div>
					</div>
				</span>
			</el-tab-pane>
		</el-tabs>

		<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" size="mini" :max-height="maxHeight">
			<el-table-column type="selection" width="45" align="center"></el-table-column>
			<el-table-column align="center" prop="id" width="50" label="编号" fixed="left"></el-table-column>
			<el-table-column label="交易号" width="80">
				<template slot-scope="scope">
					<div class="media" style="display: flex;align-items: center;">{{ scope.row.jyh }}</div>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="szje" width="80" label="支出金额"></el-table-column>
			<el-table-column align="center" width="100" label="审核状态">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain v-if="scope.row.shzt == 0">待审核</el-button>
					<el-button type="success" size="mini" plain v-else-if="scope.row.shzt == 1">已通过</el-button>
					<el-button type="warning" size="mini" plain v-else>不通过</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="100" label="结算状态">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain v-if="scope.row.jszt == 0">待结算</el-button>
					<el-button type="success" size="mini" plain v-else>已结算</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="100" label="付款账户">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>{{scope.row.skzh.mc}}</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="100" label="支出类别">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain v-if="scope.row.zclb == null">无</el-button>
					<el-button type="success" size="mini" plain v-else>{{scope.row.zclb.mc}}</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="130" label="单据类型">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain v-if="scope.row.djlx == null">无</el-button>
					<el-button type="success" size="mini" plain v-else>{{scope.row.djlx}}</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="100" label="业务员">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>{{scope.row.ywy.name}}</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="100" label="创建时间">
				<template slot-scope="scope">
					{{scope.row.create_time.slice(0,10)}}
				</template>
			</el-table-column>
			<el-table-column align="center" width="100" label="结算日期">
				<template slot-scope="scope">
					{{scope.row.create_time.slice(0,10)}}
				</template>
			</el-table-column>
			<!-- 操作 -->
			<el-table-column align="center" label="操作" fixed="right" width="240">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" @click="navigate('cwgl_zcjz_fkdd_create',scope.row)">编辑</el-button>
					<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					<el-button type="warning" size="mini" @click="opctb(scope.row.id,0)">结算确认</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="height: 60px;"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>

		<el-drawer title="企业微信消息发送" :visible.sync="drawera" :direction="direction" size="600px">
			<div class="ml-4 mr-4" style="width: 100%;">
				<el-form ref="form" label-width="80px">
					<el-form-item label="信息数量"><el-input v-model="form.xxsl" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="标题字段">
						<el-select v-model="form.btzd" placeholder="请选择" size="mini">
							<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="消息标题"><el-input v-model="form.xxbt" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="卡片描述">
						<el-select v-model="form.kpms" placeholder="请选择" size="mini">
							<el-option v-for="item in optionss" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="卡片链接"><el-input v-model="form.kplj" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="接收对象">
						<el-radio-group v-model="form.jsdx" size="mini">
							<el-radio-button label="0">个人</el-radio-button>
							<el-radio-button label="1">部门</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="选择范围">
						<el-select v-model="form.xzfw" filterable placeholder="请选择">
						    <el-option v-for="item in grlist" :key="item.id" :label="item.name" :value="item.id" v-if="form.jsdx == 0"></el-option>
							<el-option v-for="item in bmlist" :key="item.id" :label="item.name" :value="item.id" v-else></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</el-drawer>
		<el-dialog title="结算" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<span>1条订单成功结算</span>
			  <span slot="footer" class="dialog-footer">
			    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			  </span>
		</el-dialog>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			multipleSelection: [],
			preUrl: 'cwskdd',
			maxHeight: 0,
			tabIndex: 0,
			tableData: [],
			tabbars: [
				{ name: '全部账单', key: 'all' ,num:0},
				{ name: '待审核', key: 'dsh' ,num:0},
				{ name: '已审核', key: 'ysh' ,num:0},
				{ name: '待结算', key: 'djs' ,num:0},
				{ name: '已结算', key: 'yjs' ,num:0},
			],
			drawera: false,
			grlist:[],
			bmlist:[],
			cwzjlist:[],
			
			form: {},
			cateOptions: [],
			value: '更多',
			dialogVisible: false,
			direction: 'rtl',
			options: [
				{
					id: 0,
					name: '订单号'
				},
				{
					id: 1,
					name: '商品总额'
				},
				{
					id: 2,
					name: '订单金额'
				},
				{
					id: 3,
					name: '待结算金额'
				},
				{
					id: 4,
					name: '产品数量'
				},
				{
					id: 5,
					name: '客户'
				},
				{
					id: 6,
					name: '审核状态'
				},
				{
					id: 7,
					name: '出库状态'
				},
				{
					id: 8,
					name: '付款状态'
				},
				{
					id: 9,
					name: '业务员'
				},
				{
					id: 10,
					name: '下单时间'
				}
			],
			optionss: [
				{
					id: 0,
					name: '您有新的消息，请点击进入详情查看。'
				},
				{
					id: 1,
					name: '您有新的订单，请及时处理。'
				},
				{
					id: 2,
					name: '您有新的工作，请查看。'
				}
			],
			num: 99
		};
	},
	filters: {
		tree(item) {
			if (item.level == 0) {
				return item.name;
			}
			let str = '';
			for (let i = 0; i < item.level; i++) {
				str += i == 0 ? '|--' : '--';
			}
			return str + ' ' + item.name;
		}
	},
	computed: {
		...mapState({
			user: state => state.user.user
		}),
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 290;
		});
		this.axios.get('/admin/managers/list',{
			token: true
		}).then(res => {
			this.grlist = res.data.data
		})
		this.axios.get('/admin/bumens/list',{
			token: true
		}).then(res => {
			this.bmlist = res.data.data
		})
		this.axios.get('/admin/cwzj/1',{
			token: true
		}).then(res => {
			this.cwzjlist = res.data.data.list
		})
		
	},
	methods: {
		getList() {
			if(this.preUrl == '') return
			this.showLoading()
			let url = this.getListUrl()
			this.axios.get(url, { // 商品规格 api
				token: true
			}).then(res => {
				let data = res.data.data
				this.page.total = data.totalCount // 获取分页信息
				this.getListResult(data) // 获取到的数据储存到getListResult(data)，方便外面调用修改
				this.tabbars[1].num = data.dsh
				this.tabbars[3].num = data.djs
				this.hideLoading()
			}).catch(err => {
				this.hideLoading()
			})
		},
		states(e, f) {
			if (f.length == 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的订单'
				});
			}else{
				let x = f.map(i => {
					return i.id;
				});
				let i = {
					shzt: e,
					ids: x
				};
				this.axios.post('/admin/cwmx/update_status', i,{
					token: true
				}).then(res => {
					this.getList()
				})
			}
			
		},
		
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 鼠标单击的事件
		navigate(name, e) {
			if (!e) {
				var data = {
					jyh: '自动生成',
					djlx: '付款订单',
					desc: '',
					ywy: '',
					xm: '',
					bm: '',
					kh: '',
					gys: '',
					zclb: '',
					skzh:'',
					sfgz:0,
					scpj:'',
					cjr: this.user.id,
					szje: 0,
					jzlx:1
				};
			} else {
				var data = {
					jyh: e.jyh,
					djlx: e.djlx,
					desc: e.desc,
					id: e.id,
					ywy: e.ywy.id,
					xm: e.xm,
					bm: e.bm.id,
					kh: e.kh.id,
					gys: e.gys==null ? '':e.gys.id,
					zclb: e.zclb.id,
					skzh:e.skzh.id,
					sfgz:e.sfgz,
					scpj:e.scpj,
					cjr: this.user.id,
					szje: e.szje,
				};
			}
			this.$router.push({
				name,
				params: { data }
			});
		},

		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}/付款订单?limit=${this.page.size}&tab=${this.tab}${this.params}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			this.tableData = e.list
			this.cateOptions = e.cates
			this.tabbars[1].num = e.dsh
			this.tabbars[3].num = e.djs
		},

		// 清空筛选条件
		clearSearch() {
			this.form = {
				title: '',
				category_id: ''
			};
		},
		// 搜索事件
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.form.title = e;
			}
			// 高级搜索
			this.getList();
		},

		opcta(f) {
			if (f.length == 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的订单'
				});
			}else{
				this.form = {
					xxsl:f.length,
					btzd:0,
					xxbt:'',
					kpms:'',
					kplj:'',
					jsdx:0,
					xzfw:''
				}
				this.drawera = true;
			}
		},
		opctb(e,f) {
			console.log(e,f)
			if(f == 0){
				let x = [e]
				console.log(x)
				this.axios.post('/admin/cwfk/jszt', x, {
					token: true
				}).then(res => {
					console.log(res)
					this.getList()
				})
				this.dialogVisible = true;
			}else if (e.length == 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的订单'
				});
			}else{
				let x = e.map(i=>{
					return i.id
				})
				console.log(x)
				this.axios.post('/admin/cwfk/jszt', x, {
					token: true
				}).then(res => {
					console.log(res)
					this.getList()
				})
				this.dialogVisible = true;
			}
			
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
</style>
